// extracted by mini-css-extract-plugin
export default {"handleBoxLeft":"handleBoxLeft-aZQIZ","searchInput":"searchInput-hrAQ3","input":"input-MCMFf","searchButton":"searchButton-Y1ILQ"};